import { useScrollReveal } from '@/hooks/useScrollReveal';

const AsyncDelivery = () => {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section
      ref={ref}
      data-testid="async-section"
      className={`section-reveal ${isVisible ? 'visible' : ''}`}
      style={{ backgroundColor: '#3A3D42' }}
    >
      <div className="content-narrow">
        <p className="section-label" data-testid="async-label">How it works</p>

        <p className="body-text-secondary mt-5" data-testid="async-body">
          Your thinking space, not my calendar constraints. I review what you send &mdash; pitch decks, dashboards, team dynamics, positioning docs &mdash; and return structured analysis via Loom walkthroughs, voice notes, and written briefs. When a live conversation moves things faster, we have one. You get depth without scheduling overhead.
        </p>
      </div>
    </section>
  );
};

export default AsyncDelivery;
